import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import 'AppSrc/core/style/components/app-layout/page-content.css';
import 'AppSrc/core/style/components/crqs-screen/crqs-screen.css';
import {
  CRQ_STATUSES,
  CRQ_STATUS_DISPLAY_NAMES,
  getCrqListStatusParameter,
} from 'AppSrc/core/crq/crq-statuses';
import { connect } from 'react-redux';
import {
  fetchCrqList,
  clearCrqList,
  clearCrqListError,
} from 'AppSrc/core/crq/crq-list-actions';
import { FIXED, MOBILE } from 'AppSrc/core/components/forms/value-dependency-constants';
import { REQUESTER } from 'AppSrc/core/components/forms/form-base-components/data-structure/constants';
import { orderedGroupsSelector } from 'AppSrc/core/auth/auth-selectors';
import { CrqListTable } from './crq-list-table';
import { CrqListFilters } from './crq-list-filters';
import { CrqListErrorAlert } from './crq-list-error-alert';
import { BackAndRefresh } from '../utility/back-refresh';
// import { CrqWorkQueueDisplay } from './crq-work-queue-display';
// import { DEFAULT_TAB } from './crq-work-queue-constants';


// return status name and id for a status parameter string
const getStatusData = (status) => {
  const statusId = status ? CRQ_STATUSES[status] : null;
  // if the status exists, return status details
  if (statusId) {
    return ({
      statusId,
      statusName: CRQ_STATUS_DISPLAY_NAMES[statusId],
    });
  }
  // return default status
  return ({
    statusId: null, // opened is not an actual status
    statusName: 'Opened',
  });
};

const getTitle = ({
  statusName,
  coordinatorGroupName,
}) => {
  // if a coordinator group is set, use that as the title
  if (coordinatorGroupName) {
    return coordinatorGroupName;
  }
  // title should be the status name
  return `${statusName} CRQs`;
};

const CrqsScreenDisplay = ({
  isFetching,
  crqList,
  fetchCrqs,
  coordinatorGroupName,
  network,
  status,
  hasError,
  clearError,
  isRequesterForBothNetworks,
}) => {
  const { statusName, statusId } = getStatusData(status);
  const [filters, setFilters] = useState({});
  // const [selectedTab, setSelectedTab] = useState(DEFAULT_TAB);
  useEffect(
    () => {
      fetchCrqs({
        statusId,
        network,
        coordinatorGroupName,
        isRequesterForBothNetworks,
      });
    },
    [statusId, fetchCrqs, network, coordinatorGroupName, isRequesterForBothNetworks],
  );
  const title = getTitle({
    statusName,
    coordinatorGroupName,
  });
  // const handleTabClick = (tab) => {
  //   setSelectedTab(tab);
  // };
  window.sessionStorage.removeItem('getCurrentAdjacentRemedyRef');
  window.sessionStorage.removeItem('statusReason');
  // hide the status filter we are viewing closed or cancelled crqs
  const showStatusFilter = !statusId;
  const noResultsMessage = `No ${statusName.toLowerCase()} CRQs found`;
  // show work queue with Open status and fixed network
  // const isShowWorkQueue = !statusId && network === FIXED;
  const isDuplicate = true;

  return (
    <div className="page-content-container crq-screen-container">
      <div className="page-top">
        <h1 className="page-title">
          {title}
        </h1>
        <BackAndRefresh />
      </div>
      <div className="page-content">
        {/* {
          isShowWorkQueue ? (
            // <CrqWorkQueueDisplay
            //   crqList={crqList}
            //   fetching={isFetching}
            //   selectedTab={selectedTab}
            //   handleTabClick={handleTabClick}
            //   stats={{
            //     approval: 3,
            //     review: 9,
            //     peer: 7,
            //     preclosure: 10,
            //   }}
            // />
            ''
          ) : (
            <>
              <CrqListFilters
                key={status}
                currentFilters={filters}
                setFilters={setFilters}
                showStatuses={showStatusFilter}
                listIsSearch={false} // TODO pass in correct value when implementing search
              />
              <CrqListTable
                fetching={isFetching}
                crqList={crqList}
                noResultsMessage={noResultsMessage}
                filters={filters}
              />
            </>
          )
        } */}
        <>
          <CrqListFilters
            key={status}
            currentFilters={filters}
            setFilters={setFilters}
            showStatuses={showStatusFilter}
            listIsSearch={false} // TODO pass in correct value when implementing search
          />
          <CrqListTable
            fetching={isFetching}
            crqList={crqList}
            noResultsMessage={noResultsMessage}
            filters={filters}
            coordinatorGroupName={coordinatorGroupName}
            isDuplicate={isDuplicate}
          />
        </>
      </div>
      { hasError && (
        <CrqListErrorAlert
          clearError={clearError}
        />
      )}
    </div>
  );
};

CrqsScreenDisplay.propTypes = {
  isFetching: PropTypes.bool,
  crqList: PropTypes.arrayOf(PropTypes.object),
  fetchCrqs: PropTypes.func,
  coordinatorGroupName: PropTypes.string,
  network: PropTypes.string,
  status: PropTypes.string,
  hasError: PropTypes.bool,
  clearError: PropTypes.func,
  isRequesterForBothNetworks: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => {
  const {
    isFetching,
    crqList,
    hasError,
  } = state.crqList;
  const { coordinatorGroupParam, networkParam } = ownProps;
  const { roles } = state.auth.user;

  const orderedCoordinatorGroups = orderedGroupsSelector(state);
  const defaultGroup = orderedCoordinatorGroups.find((group) => group.default);

  // treat incoming 'all' params for network or coordinator group as null
  const groupNameFromParam = coordinatorGroupParam === 'all' ? null : coordinatorGroupParam;
  const networkFromParam = networkParam === 'all' ? null : networkParam;

  // if no network or group is specified and there is a default group,
  // use the network and groupname from that
  const useDefaultGroup = !groupNameFromParam && !networkFromParam && defaultGroup;
  const coordinatorGroupName = useDefaultGroup ? defaultGroup.name : groupNameFromParam;
  const network = useDefaultGroup ? defaultGroup.network : networkFromParam;

  const isRequesterForBothNetworks = (roles[MOBILE] === REQUESTER && roles[FIXED] === REQUESTER);
  return ({
    isFetching,
    crqList,
    hasError,
    isRequesterForBothNetworks,
    coordinatorGroupName,
    network,
  });
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchCrqs({
    statusId,
    network,
    coordinatorGroupName,
    isRequesterForBothNetworks,
  }) {
    // first clear any existing crqs in state
    dispatch(clearCrqList());
    // only fetch crqs if there is a coordiator group name or network set
    // or user is a requester on both networks
    if (coordinatorGroupName || network || isRequesterForBothNetworks) {
      const params = {
        coordinator_group: coordinatorGroupName,
        status: getCrqListStatusParameter(statusId),
        network,
      };
      dispatch(fetchCrqList(params));
    }
  },
  clearError() {
    dispatch(clearCrqListError());
  },
});

const CrqsScreenDisplayConnected = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CrqsScreenDisplay);

const CrqsScreen = () => {
  const {
    status,
    network,
    coordinatorGroup,
  } = useParams();
  const key = `${network}-${coordinatorGroup}-${status}`;
  return (
    <CrqsScreenDisplayConnected
      key={key} // rerender whenever params change
      status={status}
      networkParam={network}
      coordinatorGroupParam={coordinatorGroup}
    />
  );
};

export {
  CrqsScreenDisplay,
  CrqsScreen,
};
